// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animloader {
  0% {
    left: 0;
    transform: translateX(-100%);
  }
  100% {
    left: 100%;
    transform: translateX(0%);
  }
}
.lsn-new-button.as-link,
.lsn-new-button.as-icon {
  background: none;
  box-shadow: none;
  border: 0;
  display: flex;
  align-items: baseline;
  width: initial;
  padding: 0;
  cursor: pointer;
}
.lsn-new-button.as-link:is(.as-icon),
.lsn-new-button.as-icon:is(.as-icon) {
  font-size: var(--main-font-size-icon);
}
.lsn-new-button.as-link:is(.as-link),
.lsn-new-button.as-icon:is(.as-link) {
  font-size: var(--main-font-size-links);
}
.lsn-new-button.as-link:is(.as-link):focus,
.lsn-new-button.as-icon:is(.as-link):focus,
.lsn-new-button.as-link:is(.as-link):visited,
.lsn-new-button.as-icon:is(.as-link):visited,
.lsn-new-button.as-link:is(.as-link):active,
.lsn-new-button.as-icon:is(.as-link):active,
.lsn-new-button.as-link:is(.as-link):hover,
.lsn-new-button.as-icon:is(.as-link):hover {
  text-decoration: underline;
}
.lsn-new-button.as-link .button-inner-icon,
.lsn-new-button.as-icon .button-inner-icon {
  text-decoration: none !important;
}
.lsn-new-button.as-link:focus,
.lsn-new-button.as-icon:focus {
  box-shadow: 0 0 0 2px var(--main-text-color);
}
.lsn-new-button.as-link.type-primary,
.lsn-new-button.as-icon.type-primary {
  color: var(--main-primary-color);
}
.lsn-new-button.as-link.type-primary:focus,
.lsn-new-button.as-icon.type-primary:focus {
  box-shadow: 0 0 0 2px var(--main-primary-color);
}
.lsn-new-button.as-link.type-secondary,
.lsn-new-button.as-icon.type-secondary {
  color: var(--main-primary-color);
}
.lsn-new-button.as-link.type-secondary:focus,
.lsn-new-button.as-icon.type-secondary:focus {
  box-shadow: 0 0 0 2px var(--main-primary-color);
}
.lsn-new-button.as-link.type-danger,
.lsn-new-button.as-icon.type-danger {
  color: var(--main-red);
}
.lsn-new-button.as-link.type-danger:focus,
.lsn-new-button.as-icon.type-danger:focus {
  box-shadow: 0 0 0 2px var(--main-red);
}
.lsn-new-button.as-link.var-disabled,
.lsn-new-button.as-icon.var-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
}
.lsn-new-button.as-button {
  margin: 0px;
  font-weight: normal;
  border-radius: var(--main-border-radius);
  font-size: var(--main-font-size-button);
  line-height: calc(var(--main-font-size-button) * 1.5);
  font-family: var(--main-font-family);
  cursor: pointer;
  padding-inline: 1.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  color: var(--main-white);
  background-color: var(--main-text-color);
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-white), var(--main-text-color));
}
.lsn-new-button.as-button:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button:not(.var-disabled):focus,
.lsn-new-button.as-button:not(.var-disabled):visited,
.lsn-new-button.as-button:not(.var-disabled):hover:not(.busy) {
  color: var(--main-white);
  background-color: color-mix(in srgb, var(--main-text-color), var(--main-white) 10%);
}
.lsn-new-button.as-button:not(.var-disabled).busy,
.lsn-new-button.as-button:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, var(--main-text-color) 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.var-outline {
  color: var(--main-text-color);
  background-color: transparent;
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-text-color), transparent);
}
.lsn-new-button.as-button.var-outline:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.var-outline:not(.var-disabled):focus,
.lsn-new-button.as-button.var-outline:not(.var-disabled):visited,
.lsn-new-button.as-button.var-outline:not(.var-disabled):hover:not(.busy) {
  color: var(--main-text-color);
  background-color: color-mix(in srgb, transparent, var(--main-text-color) 10%);
}
.lsn-new-button.as-button.var-outline:not(.var-disabled).busy,
.lsn-new-button.as-button.var-outline:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, transparent 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.var-outline:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.var-ghost,
.lsn-new-button.as-button.var-ghost:hover,
.lsn-new-button.as-button.var-ghost:focus,
.lsn-new-button.as-button.var-ghost:active,
.lsn-new-button.as-button.var-ghost:visited {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
  color: var(--main-text-color) !important;
}
.lsn-new-button.as-button.var-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
  color: color-mix(in srgb, var(--main-black), var(--main-white) 30%);
}
.lsn-new-button.as-button.var-disabled:not(.var-ghost):not(.var-outline) {
  background-color: color-mix(in srgb, var(--main-black) 30%, transparent);
}
.lsn-new-button.as-button.busy {
  position: relative;
  overflow: hidden;
  background-color: color-mix(in srgb, var(--main-text-color), transparent);
  cursor: wait;
}
.lsn-new-button.as-button.busy .busy-animation {
  width: 192px;
  height: 4.8px;
  background: color-mix(in srgb, var(--main-text-color), var(--main-black));
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  animation: animloader 3s linear infinite;
}
.lsn-new-button.as-button.type-primary {
  color: var(--main-white);
  background-color: var(--main-primary-color);
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-white), var(--main-primary-color));
}
.lsn-new-button.as-button.type-primary:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-primary:not(.var-disabled):focus,
.lsn-new-button.as-button.type-primary:not(.var-disabled):visited,
.lsn-new-button.as-button.type-primary:not(.var-disabled):hover:not(.busy) {
  color: var(--main-white);
  background-color: color-mix(in srgb, var(--main-primary-color), var(--main-white) 10%);
}
.lsn-new-button.as-button.type-primary:not(.var-disabled).busy,
.lsn-new-button.as-button.type-primary:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, var(--main-primary-color) 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-primary:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-primary.var-outline {
  color: var(--main-primary-color);
  background-color: transparent;
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-primary-color), transparent);
}
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled):focus,
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled):visited,
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled):hover:not(.busy) {
  color: var(--main-primary-color);
  background-color: color-mix(in srgb, transparent, var(--main-primary-color) 10%);
}
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled).busy,
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, transparent 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-primary.var-outline:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-primary.var-ghost,
.lsn-new-button.as-button.type-primary.var-ghost:hover,
.lsn-new-button.as-button.type-primary.var-ghost:focus,
.lsn-new-button.as-button.type-primary.var-ghost:active,
.lsn-new-button.as-button.type-primary.var-ghost:visited {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
  color: var(--main-primary-color) !important;
}
.lsn-new-button.as-button.type-primary.var-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
  color: color-mix(in srgb, var(--main-black), var(--main-white) 30%);
}
.lsn-new-button.as-button.type-primary.var-disabled:not(.var-ghost):not(.var-outline) {
  background-color: color-mix(in srgb, var(--main-black) 30%, transparent);
}
.lsn-new-button.as-button.type-primary.busy {
  position: relative;
  overflow: hidden;
  background-color: color-mix(in srgb, var(--main-primary-color), transparent);
  cursor: wait;
}
.lsn-new-button.as-button.type-primary.busy .busy-animation {
  width: 192px;
  height: 4.8px;
  background: color-mix(in srgb, var(--main-primary-color), var(--main-black));
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  animation: animloader 3s linear infinite;
}
.lsn-new-button.as-button.type-secondary {
  color: var(--main-white);
  background-color: var(--main-primary-color);
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-white), var(--main-primary-color));
}
.lsn-new-button.as-button.type-secondary:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-secondary:not(.var-disabled):focus,
.lsn-new-button.as-button.type-secondary:not(.var-disabled):visited,
.lsn-new-button.as-button.type-secondary:not(.var-disabled):hover:not(.busy) {
  color: var(--main-white);
  background-color: color-mix(in srgb, var(--main-primary-color), var(--main-white) 10%);
}
.lsn-new-button.as-button.type-secondary:not(.var-disabled).busy,
.lsn-new-button.as-button.type-secondary:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, var(--main-primary-color) 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-secondary:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-secondary.var-outline {
  color: var(--main-primary-color);
  background-color: transparent;
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-primary-color), transparent);
}
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled):focus,
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled):visited,
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled):hover:not(.busy) {
  color: var(--main-primary-color);
  background-color: color-mix(in srgb, transparent, var(--main-primary-color) 10%);
}
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled).busy,
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, transparent 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-secondary.var-outline:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-secondary.var-ghost,
.lsn-new-button.as-button.type-secondary.var-ghost:hover,
.lsn-new-button.as-button.type-secondary.var-ghost:focus,
.lsn-new-button.as-button.type-secondary.var-ghost:active,
.lsn-new-button.as-button.type-secondary.var-ghost:visited {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
  color: var(--main-primary-color) !important;
}
.lsn-new-button.as-button.type-secondary.var-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
  color: color-mix(in srgb, var(--main-black), var(--main-white) 30%);
}
.lsn-new-button.as-button.type-secondary.var-disabled:not(.var-ghost):not(.var-outline) {
  background-color: color-mix(in srgb, var(--main-black) 30%, transparent);
}
.lsn-new-button.as-button.type-secondary.busy {
  position: relative;
  overflow: hidden;
  background-color: color-mix(in srgb, var(--main-primary-color), transparent);
  cursor: wait;
}
.lsn-new-button.as-button.type-secondary.busy .busy-animation {
  width: 192px;
  height: 4.8px;
  background: color-mix(in srgb, var(--main-primary-color), var(--main-black));
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  animation: animloader 3s linear infinite;
}
.lsn-new-button.as-button.type-danger {
  color: var(--main-white);
  background-color: var(--main-red);
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-white), var(--main-red));
}
.lsn-new-button.as-button.type-danger:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-danger:not(.var-disabled):focus,
.lsn-new-button.as-button.type-danger:not(.var-disabled):visited,
.lsn-new-button.as-button.type-danger:not(.var-disabled):hover:not(.busy) {
  color: var(--main-white);
  background-color: color-mix(in srgb, var(--main-red), var(--main-white) 10%);
}
.lsn-new-button.as-button.type-danger:not(.var-disabled).busy,
.lsn-new-button.as-button.type-danger:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, var(--main-red) 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-danger:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-danger.var-outline {
  color: var(--main-red);
  background-color: transparent;
  border: var(--main-border-width) solid color-mix(in srgb, var(--main-red), transparent);
}
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled) {
  box-shadow: inset 0 -3px 5px -1px var(--main-white);
}
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled):focus,
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled):visited,
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled):hover:not(.busy) {
  color: var(--main-red);
  background-color: color-mix(in srgb, transparent, var(--main-red) 10%);
}
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled).busy,
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled):active {
  box-shadow: inset 0 3px 5px -1px color-mix(in srgb, transparent 1%, #000);
  vertical-align: 0.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
}
.lsn-new-button.as-button.type-danger.var-outline:not(.var-disabled):focus {
  outline: none;
}
.lsn-new-button.as-button.type-danger.var-ghost,
.lsn-new-button.as-button.type-danger.var-ghost:hover,
.lsn-new-button.as-button.type-danger.var-ghost:focus,
.lsn-new-button.as-button.type-danger.var-ghost:active,
.lsn-new-button.as-button.type-danger.var-ghost:visited {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
  color: var(--main-red) !important;
}
.lsn-new-button.as-button.type-danger.var-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
  color: color-mix(in srgb, var(--main-black), var(--main-white) 30%);
}
.lsn-new-button.as-button.type-danger.var-disabled:not(.var-ghost):not(.var-outline) {
  background-color: color-mix(in srgb, var(--main-black) 30%, transparent);
}
.lsn-new-button.as-button.type-danger.busy {
  position: relative;
  overflow: hidden;
  background-color: color-mix(in srgb, var(--main-red), transparent);
  cursor: wait;
}
.lsn-new-button.as-button.type-danger.busy .busy-animation {
  width: 192px;
  height: 4.8px;
  background: color-mix(in srgb, var(--main-red), var(--main-black));
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  animation: animloader 3s linear infinite;
}
.lsn-new-button.as-button.small {
  width: 100px;
}
.lsn-new-button.as-button.large {
  width: 300px;
}
.lsn-new-button.has-tooltip {
  position: relative;
}
.lsn-new-button.has-tooltip:hover .tooltip-content {
  transition: all 500ms;
  opacity: 1;
  transform: translateX(-50%) scale(1);
}
.lsn-new-button.has-tooltip .tooltip-content {
  opacity: 0;
  position: absolute;
  background: var(--main-primary-color);
  color: var(--main-bg-color-lighter);
  box-shadow: 0px 2px 10px #000;
  border: var(--main-border-width) solid var(--main-black);
  transition: all 500ms;
  top: 150%;
  z-index: 1;
  padding: 0.4rem;
  left: 50%;
  min-width: 200px;
  max-width: 320px;
  transform: translateX(-50%) scale(0.1);
  width: max-content;
  line-height: 1.2rem;
  font-size: var(--main-font-size-button);
  line-height: calc(var(--main-font-size-button) * 1.5);
  font-family: var(--main-font-family);
}
.lsn-new-button.has-tooltip .tooltip-content:before {
  content: '';
  position: absolute;
  z-index: 1;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: 10px solid var(--main-black);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}
.lsn-new-button.has-tooltip .tooltip-content:after {
  content: '';
  position: absolute;
  z-index: 2;
  top: -8.5px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: 10px solid var(--main-primary-color);
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}
.lsn-new-button .button-inner-left-icon {
  font-size: var(--main-font-size-icon);
  margin-right: 0.3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Button/Button.less"],"names":[],"mappings":"AAYE;EACE;IACE,OAAA;IACA,4BAAA;EAXJ;EAcE;IACE,UAAA;IACA,yBAAA;EAZJ;AACF;AAqGE;;EAEE,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AAnGJ;AAqGI;;EACE,qCAAA;AAlGN;AAqGI;;EACE,sCAAA;AAlGN;AAoGM;;;;;;;;EAIE,0BAAA;AA9FR;AAwEE;;EA2BI,gCAAA;AA/FN;AAkGI;;EACE,4CAAA;AA/FN;AAkGI;;EACE,gCAAA;AA/FN;AAiGM;;EACE,+CAAA;AA9FR;AAkGI;;EACE,gCAAA;AA/FN;AAiGM;;EACE,+CAAA;AA9FR;AAkGI;;EACE,sBAAA;AA/FN;AAiGM;;EACE,qCAAA;AA9FR;AAkGI;;EACE,oBAAA;EACA,mBAAA;AA/FN;AAmGE;EACE,WAAA;EACA,mBAAA;EACA,wCAAA;EACA,uCAAA;EACA,qDAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EAGA,oBAAA;EACA,uBAAA;EAhKA,wBAAA;EACA,wCAAA;EACA,oGAAA;AA8DJ;AA5DI;EACE,mDAAA;AA8DN;AA5DM;;;EAGE,wBAAA;EACA,mFAAA;AA8DR;AA3DM;;EAEE,oFAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AA2DR;AAvDM;EACE,aAAA;AAyDR;AAhDI;EAnCA,6BAAA;EACA,6BAAA;EACA,8FAAA;AAsFJ;AApFI;EACE,mDAAA;AAsFN;AApFM;;;EAGE,6BAAA;EACA,6EAAA;AAsFR;AAnFM;;EAEE,yEAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AAmFR;AA/EM;EACE,aAAA;AAiFR;AAjEM;;;;;EAKE,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,wCAAA;AAmER;AA/DI;EACE,oBAAA;EACA,mBAAA;EACA,mEAAA;AAiEN;AA/DM;EACE,wEAAA;AAiER;AA7DI;EACE,kBAAA;EACA,gBAAA;EACA,yEAAA;EACA,YAAA;AA+DN;AAnEI;EAOI,YAAA;EACA,aAAA;EACA,yEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wCAAA;AA+DR;AAyBI;EAtKA,wBAAA;EACA,2CAAA;EACA,uGAAA;AAgJJ;AA9II;EACE,mDAAA;AAgJN;AA9IM;;;EAGE,wBAAA;EACA,sFAAA;AAgJR;AA7IM;;EAEE,uFAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AA6IR;AAzIM;EACE,aAAA;AA2IR;AAlII;EAnCA,gCAAA;EACA,6BAAA;EACA,iGAAA;AAwKJ;AAtKI;EACE,mDAAA;AAwKN;AAtKM;;;EAGE,gCAAA;EACA,gFAAA;AAwKR;AArKM;;EAEE,yEAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AAqKR;AAjKM;EACE,aAAA;AAmKR;AAnJM;;;;;EAKE,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2CAAA;AAqJR;AAjJI;EACE,oBAAA;EACA,mBAAA;EACA,mEAAA;AAmJN;AAjJM;EACE,wEAAA;AAmJR;AA/II;EACE,kBAAA;EACA,gBAAA;EACA,4EAAA;EACA,YAAA;AAiJN;AArJI;EAOI,YAAA;EACA,aAAA;EACA,4EAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wCAAA;AAiJR;AArDI;EA1KA,wBAAA;EACA,2CAAA;EACA,uGAAA;AAkOJ;AAhOI;EACE,mDAAA;AAkON;AAhOM;;;EAGE,wBAAA;EACA,sFAAA;AAkOR;AA/NM;;EAEE,uFAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AA+NR;AA3NM;EACE,aAAA;AA6NR;AApNI;EAnCA,gCAAA;EACA,6BAAA;EACA,iGAAA;AA0PJ;AAxPI;EACE,mDAAA;AA0PN;AAxPM;;;EAGE,gCAAA;EACA,gFAAA;AA0PR;AAvPM;;EAEE,yEAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AAuPR;AAnPM;EACE,aAAA;AAqPR;AArOM;;;;;EAKE,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2CAAA;AAuOR;AAnOI;EACE,oBAAA;EACA,mBAAA;EACA,mEAAA;AAqON;AAnOM;EACE,wEAAA;AAqOR;AAjOI;EACE,kBAAA;EACA,gBAAA;EACA,4EAAA;EACA,YAAA;AAmON;AAvOI;EAOI,YAAA;EACA,aAAA;EACA,4EAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wCAAA;AAmOR;AAnII;EA9KA,wBAAA;EACA,iCAAA;EACA,6FAAA;AAoTJ;AAlTI;EACE,mDAAA;AAoTN;AAlTM;;;EAGE,wBAAA;EACA,4EAAA;AAoTR;AAjTM;;EAEE,6EAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AAiTR;AA7SM;EACE,aAAA;AA+SR;AAtSI;EAnCA,sBAAA;EACA,6BAAA;EACA,uFAAA;AA4UJ;AA1UI;EACE,mDAAA;AA4UN;AA1UM;;;EAGE,sBAAA;EACA,sEAAA;AA4UR;AAzUM;;EAEE,yEAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AAyUR;AArUM;EACE,aAAA;AAuUR;AAvTM;;;;;EAKE,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;AAyTR;AArTI;EACE,oBAAA;EACA,mBAAA;EACA,mEAAA;AAuTN;AArTM;EACE,wEAAA;AAuTR;AAnTI;EACE,kBAAA;EACA,gBAAA;EACA,kEAAA;EACA,YAAA;AAqTN;AAzTI;EAOI,YAAA;EACA,aAAA;EACA,kEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wCAAA;AAqTR;AAjNI;EACE,YAAA;AAmNN;AAhNI;EACE,YAAA;AAkNN;AA9ME;EACE,kBAAA;AAgNJ;AA9MI;EACE,qBAAA;EACA,UAAA;EACA,oCAAA;AAgNN;AAtNE;EAWI,UAAA;EACA,kBAAA;EACA,qCAAA;EACA,mCAAA;EACA,6BAAA;EACA,wDAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,qDAAA;EACA,oCAAA;AA8MN;AA3MM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,2CAAA;EACA,oCAAA;EACA,mCAAA;AA6MR;AAzMM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,mDAAA;EACA,oCAAA;EACA,mCAAA;AA2MR;AAtdA;EAkRI,qCAAA;EACA,oBAAA;AAuMJ","sourcesContent":[".lsn-new-button {\n  // @colorBgMain: var(--main-control-bg-color);\n  @colorPrimary: var(--main-primary-color);\n  // set secondary color to primary color for now\n  @colorSecondary: var(--main-primary-color);\n  // standard colors\n  @colorDanger: var(--main-red);\n  @colorDefault: var(--main-text-color);\n  @colorBg: var(--main-white);\n  @colorBlack: var(--main-black);\n  @colorWhite: var(--main-white);\n\n  @keyframes animloader {\n    0% {\n      left: 0;\n      transform: translateX(-100%);\n    }\n\n    100% {\n      left: 100%;\n      transform: translateX(0%);\n    }\n  }\n\n  // internal mixins\n  ._mx_colorize (@_colorText, @_colorBg) {\n    color: @_colorText;\n    background-color: @_colorBg;\n    border: var(--main-border-width) solid color-mix(in srgb, @_colorText, @_colorBg);\n\n    &:not(.var-disabled) {\n      box-shadow: inset 0 -3px 5px -1px @colorWhite;\n\n      &:focus,\n      &:visited,\n      &:hover:not(.busy) {\n        color: @_colorText;\n        background-color: color-mix(in srgb, @_colorBg, @_colorText 10%);\n      }\n\n      &.busy,\n      &:active {\n        box-shadow: inset 0 3px 5px -1px color-mix(in srgb, @_colorBg 1%, #000);\n        vertical-align: .7rem;\n\n        // press effect (button is pressed)\n        padding-top: .5rem;\n        padding-bottom: 0;\n        // end press effect\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n  }\n\n  .mx_mode (@_colorText, @_colorBg) {\n    ._mx_colorize(@_colorText, @_colorBg);\n\n    // swap colors\n    &.var-outline {\n      ._mx_colorize(@_colorBg, transparent);\n    }\n\n    // no background and no border just text\n    &.var-ghost {\n\n      &,\n      &:hover,\n      &:focus,\n      &:active,\n      &:visited {\n        background: none !important;\n        box-shadow: none !important;\n        border: none !important;\n        color: @_colorBg !important;\n      }\n    }\n\n    &.var-disabled {\n      filter: grayscale(1);\n      cursor: not-allowed;\n      color: color-mix(in srgb, @colorBlack, @colorWhite 30%);\n\n      &:not(.var-ghost):not(.var-outline) {\n        background-color: color-mix(in srgb, @colorBlack 30%, transparent);\n      }\n    }\n\n    &.busy {\n      position: relative;\n      overflow: hidden;\n      background-color: color-mix(in srgb, @_colorBg, transparent);\n      cursor: wait;\n\n      .busy-animation {\n        width: 192px;\n        height: 4.8px;\n        background: color-mix(in srgb, @_colorBg, @colorBlack);\n        position: absolute;\n        top: 0;\n        left: 0;\n        box-sizing: border-box;\n        animation: animloader 3s linear infinite;\n      }\n    }\n  }\n\n  // variations\n  &.as-link,\n  &.as-icon {\n    background: none;\n    box-shadow: none;\n    border: 0;\n    display: flex;\n    align-items: baseline;\n    width: initial;\n    padding: 0;\n    cursor: pointer;\n\n    &:is(.as-icon) {\n      font-size: var(--main-font-size-icon);\n    }\n\n    &:is(.as-link) {\n      font-size: var(--main-font-size-links);\n\n      &:focus,\n      &:visited,\n      &:active,\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .button-inner-icon {\n      text-decoration: none !important;\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 2px @colorDefault;\n    }\n\n    &.type-primary {\n      color: @colorPrimary;\n\n      &:focus {\n        box-shadow: 0 0 0 2px @colorPrimary;\n      }\n    }\n\n    &.type-secondary {\n      color: @colorSecondary;\n\n      &:focus {\n        box-shadow: 0 0 0 2px @colorSecondary;\n      }\n    }\n\n    &.type-danger {\n      color: @colorDanger;\n\n      &:focus {\n        box-shadow: 0 0 0 2px @colorDanger;\n      }\n    }\n\n    &.var-disabled {\n      filter: grayscale(1);\n      cursor: not-allowed;\n    }\n  }\n\n  &.as-button {\n    margin: 0px;\n    font-weight: normal;\n    border-radius: var(--main-border-radius);\n    font-size: var(--main-font-size-button);\n    line-height: calc(var(--main-font-size-button) * 1.5);\n    font-family: var(--main-font-family);\n    cursor: pointer;\n    padding-inline: 1.5rem;\n\n    // press effect (button is raised) this works together with the hover state\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n    // end press effect\n\n\n    .mx_mode(@colorBg, @colorDefault);\n\n    &.type-primary {\n      .mx_mode(@colorBg, @colorPrimary);\n    }\n\n    &.type-secondary {\n      .mx_mode(@colorBg, @colorSecondary);\n    }\n\n    &.type-danger {\n      .mx_mode(@colorBg, @colorDanger);\n    }\n\n    &.small {\n      width: 100px;\n    }\n\n    &.large {\n      width: 300px;\n    }\n  }\n\n  &.has-tooltip {\n    position: relative;\n\n    &:hover .tooltip-content {\n      transition: all 500ms;\n      opacity: 1;\n      transform: translateX(-50%) scale(1);\n    }\n\n    .tooltip-content {\n      transition: all 500ms;\n      opacity: 0;\n      position: absolute;\n      background: var(--main-primary-color);\n      color: var(--main-bg-color-lighter);\n      box-shadow: 0px 2px 10px #000;\n      border: var(--main-border-width) solid var(--main-black);\n      transition: all 500ms;\n      top: 150%;\n      z-index: 1;\n      padding: .4rem;\n      left: 50%;\n      min-width: 200px;\n      max-width: 320px;\n      transform: translateX(-50%) scale(.1);\n      width: max-content;\n      line-height: 1.2rem;\n      font-size: var(--main-font-size-button);\n      line-height: calc(var(--main-font-size-button) * 1.5);\n      font-family: var(--main-font-family);\n\n      // arrow\n      &:before {\n        content: '';\n        position: absolute;\n        z-index: 1;\n        top: -10px;\n        left: 50%;\n        transform: translateX(-50%);\n        border-bottom: 10px solid var(--main-black);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n      }\n\n      // arrow inner fill\n      &:after {\n        content: '';\n        position: absolute;\n        z-index: 2;\n        top: -8.5px;\n        left: 50%;\n        transform: translateX(-50%);\n        border-bottom: 10px solid var(--main-primary-color);\n        border-right: 10px solid transparent;\n        border-left: 10px solid transparent;\n      }\n    }\n  }\n\n  // inner content\n  .button-inner-left-icon {\n    font-size: var(--main-font-size-icon);\n    margin-right: .3rem;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
